export enum TrackingScheme {
  V3 = 'v3',
  V3_AD = 'v3_ad',
}

export const DefaultTrackingScheme = TrackingScheme.V3_AD;
